import { setupPaymentAccount, getProfile } from '@assembly/api/contractor'
import { Box, Typography, CircularProgress } from '@mui/material'
import React from 'react'
import { styled } from '@mui/material/styles'
import { LinkButton } from '@assembly/components'
import { useSnackbars, useAppStore } from '@assembly/hooks'
import { SnackbarType } from '@assembly/contexts'
import { getApiErrorMsg } from '@assembly/utils'

const SectionBox = styled(Box)(() => ({
  background: '#FFFFFF',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
  borderRadius: '10px',
}))

const TitleBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export default function PayoutSetup() {
  const [loading, setLoading] = React.useState(false)
  const [isProfileLoading, setIsProfileLoading] = React.useState(false)
  const { addAlert } = useSnackbars()
  const { store, setContractorProfile } = useAppStore()
  const didMountRef = React.useRef(false)

  React.useEffect(() => {
    if (!didMountRef.current) {
      if (!store.isContractorProfileLoaded) {
        loadProfile()
      }
      didMountRef.current = true
    }
  }, [])

  const loadProfile = async () => {
    try {
      setIsProfileLoading(true)
      const { data } = await getProfile()
      setContractorProfile(data)
      setIsProfileLoading(false)
    } catch (error: any) {
      setIsProfileLoading(false)
      addAlert({
        message: getApiErrorMsg(error),
        type: SnackbarType.Error,
      })
    }
  }

  const handleClickSetupPaymentAccount = async () => {
    try {
      setLoading(true)
      const { data } = await setupPaymentAccount()
      window.open(data.message, '_blank')
      setLoading(false)
    } catch (error: any) {
      console.error(error)
      setLoading(false)
      addAlert({
        message: getApiErrorMsg(error),
        type: SnackbarType.Info,
      })
    }
  }

  if (isProfileLoading) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <SectionBox>
        <Typography variant="h6">
          Your Payment Management platform is: {store.contractorProfile.payoutPlatform || 'Not set'}
        </Typography>
        <TitleBox>
          <Typography variant="h5" fontWeight={500}>
            Setup Payment Account
          </Typography>
          <LinkButton
            loading={loading}
            label="Setup"
            variant="contained"
            onClick={handleClickSetupPaymentAccount}
          />
        </TitleBox>
      </SectionBox>
    </Box>
  )
}
